module.exports = __webpack_public_path__ + "img/newsletter.7f21f40b.svg";